import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'www.staging.seek.co.nz',
    clientId: '1Hnqrqv6vRyFaZMbvqByHjmeU2h2fKqk',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.SEEK,
    contactUs: {
        en: 'https://www.seek.co.nz/contact-us/',
    },
    siteName: siteNames.candidate.seek.nz,
    zone: getZoneFromSite(siteNames.candidate.seek.nz),
    product: Product.SEEK,
};
//# sourceMappingURL=staging_seek_co_nz.js.map